import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/mobile/Routes/SellerInfo/SellerInfo.jsx");
